module.exports = __webpack_public_path__ + "static/media/bindQQ1.d66e4314.png";